import styles from "./Leaderboard.module.scss";
import FontAwesome from "../../utilities/FontAwesome";
import WatsonApi from "../../../backends/WatsonApi";
import classNames from 'classnames';
import ClickableLink from "../../utilities/ClickableLink";
import {useStores} from "../../../stores/useStores";
import {Suspense} from "react";
import {SchoolFeedMobileWidgetLink} from "../SchoolFeedMobileWidgetLink";
import LeaderboardIcon from "../../../assets/images/cficon.png";
import {withLocaleInURI} from "../../../internationalization/i18nURI";
import {IView} from "../../../stores/InterfaceStore";
import {useSchoolFeedUrlQuery} from "../../../hooks/useSchoolFeedData";

export function MobileLeaderboardWidgetLink(props: {
    active: boolean;
}) {
    const {interfaceStore} = useStores();
    const urlQuery = useSchoolFeedUrlQuery()

    return <SchoolFeedMobileWidgetLink
        href={{
            pathname: withLocaleInURI("/feed", interfaceStore.currentAppSupportedLocale),
            query: {...urlQuery, currentView: "leaderboard"}
        }}
        active={props.active}
        src={LeaderboardIcon}
        text={"Leaderboard"}
        className={styles.leaderboardLink}
    />
}

async function LeaderboardMembersList(props) {
    const {organizationStore} = useStores();

    let data: Array<{ rank: number, name: string }> = [];
    try {
        const client = await WatsonApi();
        const response = await client.apis.organizations.organizations_leaderboard({
            id: organizationStore.currentOrganization.id,
        })
        data = JSON.parse(response.data);
    } catch (e) {
        data = []
    }

    return <ol>
        {data.map(d => {
            const itemClassName = classNames({
                [styles.item]: true,
                [styles.itemIsMe]: d["me"],
            })
            return <li className={itemClassName}>
                {d.rank} - {d.name}
            </li>
        })}
    </ol>
}

export default async function Leaderboard(props) {
    const {interfaceStore} = useStores();

    return <div className={styles.container}>
        <div>
            <h3>DISCUSSION LEADERBOARD</h3>
            {interfaceStore.view !== IView.LEADERBOARD && <ClickableLink href={"/leaderboard"}
            >Learn More <FontAwesome prefix={'far'} name={'fa-question-circle'}/></ClickableLink>}
        </div>
        <Suspense>
            <LeaderboardMembersList/>
        </Suspense>
    </div>
}
